import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { defineNextPage } from '@/common/next';

import { getIsOverseaByCountryCode } from '$/common/utils/countryCodeUtil';
import { useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import { checkIsWeChat } from '$/utils';
import Styles from './index.module.scss';

function Content() {
  const [showMask, setShowMask] = useState(false);
  const languageStore = useLanguageStore((state) => state.languageStore);
  const currentCountryCode = useOfficialStore((state) => state.currentCountryCode);
  const searchParams = new URLSearchParams(window.location.search);
  const from = searchParams.get('from') || '';
  const isOpenHarmony = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('openharmony');
  };

  // 纯血鸿蒙一律跳转应用商店
  const harmonyHandler = () => {
    window.location.href = 'appmarket://details?id=com.meitu.roboneo';
  };

  const handleDownLoad = (eventName?: string) => {
    eventName && window.mtstat?.track(eventName, {
      source: from,
    });
    // 纯血鸿蒙 open-app 不支持，需要单独处理
    if (isOpenHarmony()) {
      harmonyHandler();
      return;
    }

    const isOversea = getIsOverseaByCountryCode(currentCountryCode);
    // 海外直接打开 onelink
    if (isOversea) {
      window.location.href = 'https://roboneo.onelink.me/49nX/1tubn0th';
      return;
    }

    // 使用 @meitu/open-app 唤端，失败自动引导下载
    import('@meitu/open-app').then(({ default: openApp }) => {
      openApp('roboneo', {
        scheme: 'mtroboneo://home',
        trackConfig: {
          name: { origin: 'roboneo', target: 'roboneo' },
          options: { position_id: from || 'download_page', creative_id: 'download_landing' },
        },
      });
    });
  };

  useEffect(() => {
    window.mtstat?.track('download_landing_exp', {
      source: from,
    });
    // 微信内打开时显示遮罩
    if (checkIsWeChat()) {
      setShowMask(true);
      return;
    }

    handleDownLoad();
  }, []);

  return (
    <div className={Styles.roboneo_download}>
      <div className={Styles['roboneo_download-inner']}>
        <div className={Styles['roboneo_download-title']}>
          <div className={Styles['roboneo_download-icon']} />
          <div className={Styles['roboneo_download-roboneo']} />
        </div>
        <div className={Styles['roboneo_download-subTitle']}>{languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_AI_agent_focused_on_visuals_and_design)}</div>
        <div className={Styles['roboneo_download-btn']} onClick={() => handleDownLoad('download_now_click')}>
          {languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_download_now)}
        </div>
      </div>
      {showMask && (
      <div className={Styles.download_mask}>
        <div className={Styles['download_mask-tip']}>{languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_Open_in_Browser)}</div>
      </div>
      )}
    </div>
  );
}
export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--mobile',
    layoutId: 'MobileLayout',
    renderHead() {
      return (
        <Head>
          <title>RoboNeo</title>
        </Head>
      );
    },
  },
  async getInitialProps(context) {
    return {
      title: 'download',
    };
  },
  component: () => {
    return <Content />;
  },
});
